import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigationList } from "@sprout/list-navigation";
import { useCallback, useMemo } from "react";
import InfiniteList from "@researchgate/react-intersection-list";
import { CardsWrapper } from "@sprout/client-components/dist/Cards";
import ActivityPageListItem from "./ActivityPageListItem";
const SUPPORTED_ACTIONS = [
    "OPEN"
];
const ActivityPageGroupsList = (props)=>{
    const { loading , loadMore , hasNextPage , activityGroups , subject  } = props;
    const { navProps , Provider  } = useNavigationList("ActivityPageGroupsList", useMemo(()=>({
            actions: SUPPORTED_ACTIONS
        }), []));
    const itemsRenderer = useCallback((items, ref)=>{
        return /*#__PURE__*/ _jsx(CardsWrapper, {
            ref: (element)=>{
                if (element) {
                    navProps.ref.current = element;
                    ref(element);
                }
            },
            children: items
        });
    }, [
        navProps.ref
    ]);
    const renderItem = useCallback((index)=>{
        const activityGroup = activityGroups[index];
        const previousActivityGroup = activityGroups[index - 1];
        const header = !previousActivityGroup || activityGroup.header !== previousActivityGroup.header ? activityGroup.header : null;
        const { activity , moreActivities , condition: result  } = activityGroup;
        return /*#__PURE__*/ _jsx(ActivityPageListItem, {
            header: header,
            result: result,
            subject: subject,
            activity: activity,
            moreActivities: moreActivities
        }, activity.nodeId);
    }, [
        activityGroups,
        subject
    ]);
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(InfiniteList, {
            awaitMore: loading ? false : hasNextPage,
            itemsRenderer: itemsRenderer,
            renderItem: renderItem,
            itemCount: activityGroups.length,
            onIntersection: loadMore,
            pageSize: activityGroups.length,
            threshold: "25%"
        })
    });
};
export default ActivityPageGroupsList;
